// extracted by mini-css-extract-plugin
export var content = "content-module--content--1u_hB";
export var contentInner = "content-module--content-inner--27IhK";
export var contentInnerNarrow = "content-module--content-inner--narrow--2_k44";
export var contentInnerNormal = "content-module--content-inner--normal--2qAPc";
export var contentInnerWide = "content-module--content-inner--wide--2TC8v";